import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/vendas/tabelacomissao/v1`;

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findTabelaComissao(
  empresa_cnpj,
  id,
  include,
  where = {},
  orwhere = {},
  page,
  perPage,
  fields
) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  let queryOrWhere = "";
  Object.keys(orwhere).forEach((key) => {
    queryOrWhere += `&orwhere[${key}]=${orwhere[key]}`;
  });
  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      include ? `&include=${include}` : ""
    }${page ? `&page=${page}` : ""}${perPage ? `&per_page=${perPage}` : ""}${
      fields ? `&fields${fields}` : ""
    }`,
    "GET",
    headers
  );
}

export function createTabelaComissao(empresa_cnpj, body) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export function updateTabelaComissao(id, empresa_cnpj, body) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
}

export function deleteTabelaComissao(id, empresa_cnpj) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "DELETE",
    headers
  );
}
